import type { ContentVersion } from "../../../api/content/workflowsApi";
import { listDatasets } from "../../../api/knowledgeData/knowledgeDataApi";
import type { Dataset } from "../../../api/knowledgeData/knowledgeDataDecoders";
import { getResearchSpaceProject } from "../../../api/knowledgeData/releasesApi";
import type { ResearchSpaceProject } from "../../../api/knowledgeData/releaseDecoders";
import { listModelVersions } from "../../ontology/modelVersions";
import { loadAcceptedChoices, type AcceptedChoice } from "../datasets/acceptedResults";

/** What the release steps' forms offer (K-12): model versions, accepted results, the last release and ResearchSpace. */
export interface ReleaseContext {
  readonly versions: readonly ContentVersion[];
  readonly choices: readonly AcceptedChoice[];
  /** The release series a new release continues: the dataset changed most recently. */
  readonly series: Dataset | null;
  readonly researchSpace: ResearchSpaceProject;
}

export async function loadReleaseContext(projectId: string, signal: AbortSignal): Promise<ReleaseContext> {
  const [versions, choices, datasets, researchSpace] = await Promise.all([
    listModelVersions(projectId, signal),
    loadAcceptedChoices(projectId, signal),
    listDatasets(projectId, signal),
    getResearchSpaceProject(projectId, signal),
  ]);
  return { versions, choices, series: datasets[0] ?? null, researchSpace };
}
